<template>
	<span class="school" @click="toSchoolSecond" @mouseenter="isHovering = true" @mouseleave="isHovering = false">
		<el-image :src="schooldata.Logo">
			<template #error>
				<div class="image-slot">
					<el-icon>
						<Picture />
					</el-icon>
				</div>
			</template>
		</el-image>
		<span class="name">
			<span class="gby-font">{{schooldata.Name}}</span>
			<jieDuNumber v-if="schooldata.ID" class="jieDu" :key="schooldata.ID" :refID="schooldata.ID"
				:refType="schooldata.DicType" :num='schooldata.JieDuNum'></jieDuNumber>
			<span v-if="!IsFront" v-show="isHovering" title="高校资讯" @click.stop="OpenSchNews()"><el-icon >
					<Link />
				</el-icon></span>
			<!-- 后台不加院校比较 -->
			<compareIcon v-if="!IsFront && isLogin" type="1" :refID="schooldata.ID" class="compare"></compareIcon>
		</span>

		<span class="theTag">
			<SchoolTag :schooldata="schooldata"></SchoolTag>
			<div style="margin-right: 5px;color: #999;padding-top: 5px; font-size: 14px;">{{ schooldata.ShengShi }}
			</div>
		</span>

	</span>

	<el-dialog v-if="showSchNews" v-model="showSchNews" :title="schooldata.Name+ '-资讯'" :style="{width:'1000px', minHeight: '500px',maxHeight:'500px' }" :before-close="handleClose">
		<div style="padding-left: 20px;padding-right:20px;"><SchoolNews :IsFront="IsFront" :SchID="schooldata.ID" :SchName="schooldata.Name"></SchoolNews></div>
	</el-dialog>
</template>

<script>
	import SchoolTag from './cp_school_tag.vue'
	import SchoolNews from './cp_sch_news.vue'
	export default {
		props: {
			IsFront: {
				type: Boolean,
				default: true,
				required: false,
			},
			schooldata: {
				type: Object,
				default: {},
				required: false,
			}
		},
		components: {
			SchoolTag,
			SchoolNews
		},
		data() {
			return {
				isHovering: false, // 添加悬停状态
				showSchNews: false,
			}
		},
		computed: {
			isLogin() {
				let token = this.$store.getters.getToken();
				if (token == undefined || token.length <= 0)
					return false;
				return true;
			}
		},
		methods: {
			toSchoolSecond() {
				this.$emit("toParent");
			},
			OpenSchNews() {
				this.showSchNews = true;
			}
		},
		created() {


		},
		mounted() {

		}
	}
</script>

<style scoped="scoped">
	span {
		display: inline-block;
	}

	.school {
		position: relative;
		width: 100%;
		height: 100px;
		display: inline-block;
		cursor: pointer;
		margin-top: 10px;
		margin-bottom: 10px;
	}

	.school .el-image {
		width: 100px;
		height: 100px;
		position: absolute;
		top: 0px;
		left: 0px;
	}

	.name {
		position: absolute;
		top: 20px;
		left: 120px;
		height: 30px;
		font-size: 20px;
		font-weight: 600;
		display: flex;
		justify-content: flex-start;
		align-items: center;
	}

	/* .name>*:nth-child(1) {
		margin-right: 5px;
	} */

	.name>*:nth-child(n+1) {
		margin-right: 5px;
	}

	.theTag {
		position: absolute;
		top: 60px;
		left: 120px;
		height: 50px;
	}

	.name:hover .jieDu,
	.name:hover .compare {
		display: inline-block !important;
	}

	/* .compare {
		margin-top: 8px;
	} */
</style>